import { useState, useRef, useEffect } from 'react'

/**
 * @description 节流函数, 在delay的时间内只执行一次
 * @param fn 要执行的函数
 * @param delay 默认100ms
 * @returns
 */
function useSuperLock<T extends (...args: any[]) => Promise<any>>(
  fn: T,
  delay?: number,
): [T, boolean] {
  const [isLocked, setIsLocked] = useState(false)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const lockedFn = async (...args: Parameters<T>): Promise<ReturnType<T>> => {
    if (isLocked) return Promise.resolve() as ReturnType<T>

    setIsLocked(true)
    try {
      const result = await fn(...args)
      return result
    } finally {
      timerRef.current = setTimeout(() => {
        setIsLocked(false)
        timerRef.current = null
      }, delay || 100)
    }
  }

  const unlock = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      setIsLocked(false)
      timerRef.current = null
    }
  }

  useEffect(() => {
    return () => {
      unlock()
    }
  }, [])

  return [lockedFn as T, isLocked]
}

export default useSuperLock
